import React, { useState, useEffect } from "react";
import {
  Modal, Box, Typography, TextField, Select, MenuItem, Button,
  IconButton, Divider, InputLabel, FormControl, GlobalStyles
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Editor } from "@tinymce/tinymce-react";
import SingleSelectDropdown from "../../pages/SingleSelectDropdown";
import { developerTollApi } from "../../services/developerTollApi";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  maxHeight: "90dvh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
};

const templateOptions = [
  { value: "verifyemail", label: "Verify Email" },
  { value: "updateemail", label: "Update Email" },
  { value: "confirmationemail", label: "Confirmation Email" },
  { value: "rejectionemail", label: "Rejection Email" },
  { value: "submit_application", label: "Submit Application Email" },
  { value: "esign_complete", label: "Esign Complete Email" },
  { value: "complete_application", label: "Complete Application Email" },
];

const AddTag = ({ openEditor, handleClose, selectedTag, allProducts, selectedProduct, tagEdit, fetchAllTags }) => {
  const [product, setProduct] = useState("");
  const [tagName, setTagName] = useState("");
  const [tagDescription, setTagDescription] = useState("");
  const [tagDemoUrl, setTagDemoUrl] = useState("");
  const [tagDemoThumbnailUrl, setTagDemoThumbnailUrl] = useState("");
  const [collectionUrl, setCollectionUrl] = useState("");
  const [tagType, setTagType] = useState("");
  const [body, setBody] = useState("");
  const [loader, setLoader] = useState(false);

  const typeOptions = [
    { label: "Public", value: "public" },
    { label: "Private", value: "private" },
  ];

  useEffect(() => {
    if (selectedTag && openEditor) {
      setTagName(selectedTag.tag_name || "");
      setTagDescription(selectedTag.description || "");
      setTagDemoUrl(selectedTag.demo_url || "");
      setTagDemoThumbnailUrl(selectedTag.demo_thumbnail_url || "");
      setCollectionUrl(selectedTag.collection_url || "");
      if (typeof selectedTag.is_public === "boolean") {
        setTagType(selectedTag.is_public ? "public" : "private");
      } else {
        setTagType("");
      }
      setProduct(selectedProduct || "");
      setBody(selectedTag.documentation || "");
    }
    else
    {
      setTagName("");
      setTagDescription("");
      setTagDemoUrl("");
      setTagDemoThumbnailUrl("");
      setCollectionUrl("");
      setTagType("");
      setProduct("");
      setBody("");
    }
  }, [selectedTag, openEditor]);

  const handleSave = async () => {
    console.log({ tagName, tagDescription, tagType, product, body });
    const payload={
      tag_name: tagName,
      description: tagDescription,
      demo_url: tagDemoUrl,
      demo_thumbnail_url: tagDemoThumbnailUrl,
      collection_url: collectionUrl,
      is_public: tagType == 'public' ? true : false,
      documentation: body,
      product_id: product,
    }

    if (tagEdit && selectedTag?.tag_id) {
      payload.tag_id = selectedTag.tag_id;
    }
    setLoader(true);
    try {
      let response;
      if (tagEdit && selectedTag?.tag_id) {
        response = await developerTollApi.updateTag(payload);
      } else {
        response = await developerTollApi.addTag(payload);
      }
      console.log(response)
      if(response?.status)
      {
        handleClose();
        fetchAllTags();
      }
    } catch (error) {
        console.error("Error fetching line chart data:", error);
    } finally {
        setLoader(false);
    }
  };

  return (
    <Modal open={openEditor} onClose={handleClose} disableEnforceFocus>
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="20px 30px">
          <Typography sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>Create Tag</Typography>
          <Box>
            <IconButton onClick={handleClose}><CloseIcon /></IconButton>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ p: "20px 30px", overflow: "auto", maxHeight: "calc(100vh - 245px)" }}>
          <Box>
            <TextField
              variant="outlined"
              name="tag_name"
              label="Tag Name"
              type="text"
              value={tagName}
              onChange={(e) => setTagName(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: tagName ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: tagName ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: tagName ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          <Box mt={2}>
            <TextField
              variant="outlined"
              name="description"
              label="Description"
              type="text"
              value={tagDescription}
              onChange={(e) => setTagDescription(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: tagDescription ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: tagDescription ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: tagDescription ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>
          <SingleSelectDropdown
              label={<Box sx={{ display: "flex", gap: 1}}>Product</Box>}
              value={product}
              onChange={(val) => setProduct(val)}
              options={allProducts.map(item => ({
                label: item.product_name.replace(/_/g, " "),
                value: item.product_id,
              }))}
              width="100%"
              sx={{ mt: 2}}
          />

          <SingleSelectDropdown
              label={<Box sx={{ display: "flex", gap: 1}}>Tag Type</Box>}
              value={tagType}
              onChange={(val) => setTagType(val)}
              options={typeOptions}
              width="100%"
              sx={{ mt: 2}}
          />

          <Box mt={2}>
            <TextField
              variant="outlined"
              name="demoUrl"
              label="Demo Url"
              type="text"
              value={tagDemoUrl}
              onChange={(e) => setTagDemoUrl(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: tagDemoUrl ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: tagDemoUrl ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: tagDemoUrl ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <TextField
              variant="outlined"
              name="demoThumbnailUrl"
              label="Demo Thumbnail Url"
              type="text"
              value={tagDemoThumbnailUrl}
              onChange={(e) => setTagDemoThumbnailUrl(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: tagDemoThumbnailUrl ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: tagDemoThumbnailUrl ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: tagDemoThumbnailUrl ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <TextField
              variant="outlined"
              name="collectionUrl"
              label="Collection URL"
              type="text"
              value={collectionUrl}
              onChange={(e) => setCollectionUrl(e.target.value)}
              fullWidth
              InputLabelProps={{
                sx: {
                  fontSize: "16px",
                  transform: collectionUrl ? "translate(14px, -8px) scale(0.9)" : "translate(14px, 11px) scale(1)",
                  background: collectionUrl ? "FFFFFF" : "none",
                  color: "#6F6F6F",
                  "&.Mui-focused": {
                    color: collectionUrl ? "#1D1D1D" : "#6F6F6F",
                    transform: "translate(14px, -8px) scale(0.9)",
                  },
                },
              }}
              sx={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    "& fieldset": {
                      borderColor: "#DFDFDF",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#DFDFDF",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#DFDFDF",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                  
              }}
              InputProps={{
                  sx: { 
                      fontSize: "16px",
                      fontWeight: "500",
                      height: 45,
                      "& input::-ms-reveal, & input::-ms-clear": {
                          display: "none",
                      },
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          display: "none",
                          WebkitAppearance: "none",
                          margin: 0,
                      },
                      "& input[type=number]": {
                          MozAppearance: "textfield",
                      },
                  },
              }}
            />
          </Box>

          <Box mt={2}>
            <Typography mb={1}>Documentation</Typography>
            <GlobalStyles styles={{
                '.tox-promotion': { display: 'none !important' },
                '.tox-statusbar__branding': { display: 'none !important' },
                '.tox-tinymce': { border: '1px solid #DFDFDF !important' },
            }} />
            <Editor
              apiKey='ejfq37hgybsrwmucu0b2ec7eswr1e3r0t85x0tze0snanjkq'
              value={body || "Tag Documentation"}
              onEditorChange={(newValue) => setBody(newValue)}
              init={{
                theme: "silver",
                branding: false,
                promotion: false, 
                plugins: [
                  'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link',
                  'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount', "code",
                ],
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link table code | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                tinycomments_mode: 'embedded',
                tinycomments_author: 'Author name',
                valid_elements: '*[*]',
                valid_styles: {
                  '*': 'color,font-size,font-weight,font-style,text-decoration,float,' +
                      'margin,margin-top,margin-right,margin-bottom,margin-left,' +
                      'padding,padding-top,padding-right,padding-bottom,padding-left,' +
                      'background,background-color'
                },
                paste_data_images: true,
                paste_retain_style_properties: "all",
                fullpage_default_doctype: '<!DOCTYPE html>',
                fullpage: true,
                importcss_append: true,
                content_css: false,
                relative_urls: false,
                remove_script_host: false,
                convert_urls: false,
                extended_valid_elements: 'style[type|media]',
                valid_children: '+head[style],+body[style]',
                paste_webkit_styles: "all",
                paste_data_images: true,
                paste_preprocess: (plugin, args) => {
                  // ✅ optional: force keeping <style> tag if not working
                  args.content = args.content.replace(/<style[^>]*>/g, '<style>').replace(/<\/style>/g, '</style>');
                },
              }}
            />
          </Box>
        </Box>

        <Divider mt="10px" />

        <Box display="flex" justifyContent="end" alignItems="center" p="20px 30px" gap="15px">
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={handleClose} >
                Cancel
            </Button>
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"} }} onClick={handleSave} >
                Save
            </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddTag;
